import {useQuery} from "react-query";
import DocumentDetailsApi from "./Shipment.DocumentDetails.api";

export function useDocumentData(document:any, logout:any){
    return useQuery(["fetchDocument", document], () => DocumentDetailsApi.getDocument({queryKey: [null, document]}, logout), {
        staleTime: 0 // set staleTime to zero to always make API calls
      });
}

//export function useDocumentDetailsData(query:any) {
//    return useQuery(["fetchDocumentDetailsData", query], DocumentDetailsApi.getDocumentDetailsData);
//}

export function useShipmentDocumentsData(referenceNumber:any, logout:any) {
    return useQuery(["fetchShipmentDocumentDetailsData", referenceNumber], () => DocumentDetailsApi.getDocumentsByShipmentId({queryKey: [null, referenceNumber]}, logout));
}